import type { IconProps } from "./types"

function Loader(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2048 2048"
      height="1em"
      width="1em"
      fill="currentColor"
      stroke="none"
      {...props}
      style={{
        ...props.style,
        transform: "none",
        animation: "none",
      }}
    >
      {/* =====================================================
          BLOQUE SUPERIOR
          FASE: 0
      ====================================================== */}

      <path
        d="
          M305 0
          C258 18 215 80 215 160
          C214 390 218 690 233 860
          C240 922 286 957 350 938
          C515 889 842 690 980 590
          C1055 535 1098 482 1080 435
          C1062 390 990 340 900 285
          C805 227 728 177 677 145
          C545 62 382 -16 305 0
          Z
        "
        opacity="0.2"
      >
        <animate
          attributeName="opacity"
          values="1;0.2;0.2;0.2;1"
          keyTimes="0;0.22;0.33;0.77;1"
          dur="1.4s"
          begin="0s"
          repeatCount="indefinite"
        />
      </path>

      {/* =====================================================
          BLOQUE DERECHO
          FASE: +1/3 CICLO = 400ms
      ====================================================== */}

      <path
        d="
          M1224 522
          C1170 555 1140 615 1138 700
          C1135 905 1135 1120 1138 1305
          C1140 1430 1175 1495 1255 1498
          C1405 1458 1735 1260 1880 1165
          C1960 1112 2008 1045 1980 985
          C1958 935 1880 880 1790 820
          C1708 765 1600 700 1500 640
          C1375 565 1280 505 1224 522
          Z
        "
        opacity="0.2"
      >
        <animate
          attributeName="opacity"
          values="1;0.2;0.2;0.2;1"
          keyTimes="0;0.22;0.33;0.77;1"
          dur="1.4s"
          begin="-0.4s"
          repeatCount="indefinite"
        />
      </path>

      {/* =====================================================
          BLOQUE INFERIOR
          FASE: +2/3 CICLO = 800ms
      ====================================================== */}

      <path
        d="
          M307 1095
          C258 1115 213 1175 213 1235
          C213 1450 214 1700 215 1887
          C216 1985 250 2035 346 2047
          C490 2012 810 1820 963 1714
          C1048 1655 1098 1602 1082 1555
          C1062 1508 995 1460 900 1400
          C805 1340 700 1270 628 1225
          C500 1145 375 1080 307 1095
          Z
        "
        opacity="0.2"
      >
        <animate
          attributeName="opacity"
          values="1;0.2;0.2;0.2;1"
          keyTimes="0;0.22;0.33;0.77;1"
          dur="1.4s"
          begin="-0.8s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  )
}

export default Loader